<template lang="pug">
  b-container.justify-content-md-center
    ReloadAppDialog(:showDialog="showDialog")
    TemplateModalEditor(:showDialog="templateModalOpen" :text="templateModalText" @close="handleTemplateModalClose" @cancel="handleTemplateModalCancel")
    notifications(group="request" position="top center")
    b-col(md="12")
      h2.text-center Abrir Reclamo pre-aprobado
    b-col(md="2")
    hr
    b-col(md="12")
      b-form.form-horizontal(@submit.prevent="create")
        b-row
          b-col(md="2")
          b-col
            b-row
              b-col(md="3")
                label Número de Compra
              b-col(md="9")
                b-input-group
                  b-form-input(v-model="complaint.ticket_info.booking_number")
                  b-input-group-button(slot="right")
                  .get-tickets-response(:class="ticketResponseClass")
                    icon(name="refresh" v-if="getTicketsLoader && !getTicketsError" spin)
                    icon(name="times" v-if="getTicketsError")
                    icon(name="check" v-if="booking_tickets.length > 0 && !getTicketsError && !getTicketsLoader")
                  b-btn(variant="primary" ,@click="getTickets()") Buscar
            b-form-group
              br
              b-row(v-if="booking_tickets.length > 0")
                b-col(md="3")
                  label Pasajes
                b-col(md="9")
                  selectize(multiple :select-size="4" ,:plain="true" v-model="selected" placeholder="Elige un pasaje")
                    option(v-for="t in booking_tickets" ,:key="t.id" ,:value="t.number") {{`${t.number} ${t.departure} - ${t.destination} (${t.inbound ? 'Vuelta' : 'Ida' })`}}
                  small Selecciona los pasajes afectados.
                b-col(md="3")
                  label Reclamante
                b-col(md="9")
                  b-form-group
                    b-form-input(v-model="complaint.ticket_info.fullname" :disabled="hasBusbudTicket")
                b-col(md="3")
                  label Género del reclamante
                b-col(md="9")
                  b-form-group
                    b-form-radio-group(v-model="complaint.issuer_gender" ,:options="[{ text: 'Hombre', value: 'male' }, { text: 'Mujer', value: 'female' }]" name="genderSelector" :disabled="hasBusbudTicket")

            b-form-group(v-if="complaint.ticket_info.bus_operators.length > 0" label="Empresas")
              b-form-input.form-control(:value="formatOperator(complaint.ticket_info.bus_operators)" name="complaint[ticket_info][bus_operators]"
                type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.departure_date" label="Fecha de salida (Ida)")
              b-form-input.form-control(v-model="complaint.ticket_info.departure_date" class="form-control"
                name="complaint[ticket_info][departure_date]" type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.departure_hour" label="Hora de salida (Ida)")
              b-form-input.form-control(v-model="complaint.ticket_info.departure_hour"
                name="complaint[ticket_info][departure_hour]" type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.arrival_date" label="Fecha de salida (Vuelta)")
              b-form-input(v-model="complaint.ticket_info.arrival_date" class="form-control"
                name="complaint[ticket_info][arrival_date]" type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.arrival_hour" label="Hora de salida (Vuelta)")
              b-form-input.form-control(v-model="complaint.ticket_info.arrival_hour"
                name="complaint[ticket_info][arrival_hour]" type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.payment_method" label="Método de Pago")
              b-form-input.form-control(v-model="complaint.ticket_info.payment_method"  name="complaint[ticket_info][payment_method]"
                type="text" readonly)

            b-form-group(v-if="complaint.ticket_info.price" label="Monto Total")
              b-form-input.form-control(v-model="complaint.ticket_info.price"
                name="complaint[ticket_info][price]" type="text" readonly)

            b-form-group(label="Plantillas")
              selectize(v-model="template_selected_option" name="template_selected" @input="setTemplateSelected($event)" :disabled="hasBusbudTicket")
                option(:value="''") Selecciona un motivo
                option(v-for="(template, index) in comment_templates" ,:value="template.template") {{ template.title }}
            b-form-group(v-if="template_selected" label="Texto seleccionado")
              b-form-textarea.form-control(v-model="template_selected" :rows="6" readonly)
          b-col(md="2")
        b-form-group.text-center
          br
          b-button.positive-action.btn-lg(type="submit" variant="primary" :disabled="hasBusbudTicket") Abrir reclamo pre-aprobado

</template>

<script>
import Selectize from 'vue2-selectize';
import InputTag from 'vue-input-tag';
import router from '@/router';
import kexaApi from '@/services/apiService';
import constants from '@/constants/Status.constants';
import dateService from '@/utils/dateService';
import { Validator } from 'vee-validate';
import { rutValidator } from 'vue-dni';
import TemplateModalEditor from '@/components/ui/TemplateModalEditor';

export default {
  name: 'new',
  components: {
    Selectize,
    InputTag,
    TemplateModalEditor,
  },
  computed: {
    ticketResponseClass() {
      let theClass;

      if (this.getTicketsError) {
        theClass = 'has-error';
      } else if (!this.getTicketsError && this.booking_tickets.length > 0) {
        theClass = 'tickets-found';
      }
      return theClass;
    },
  },
  data() {
    return {
      loader: false,
      getTicketsLoader: false,
      getTicketsError: false,
      bank_info: {},
      complaint: {
        fast_track: true,
        category: -1,
        comment: '',
        description: '',
        zendesk: [],
        status: 0,
        ticket_info: {
          tickets: [],
          bus_operators: [],
        },
      },
      template_selected: '',
      template_selected_option: '',
      templateModalOpen: false,
      templateModalText: '',
      booking_tickets: [],
      selected: [],
      statuses: constants.STATUSES,
      banks: constants.BANKS,
      accounts: constants.ACCOUNTS,
      comment_templates: constants.COMMENT_TEMPLATES,
      first_ticket: null,
      intervalId: null,
      showDialog: false,
      hasBusbudTicket: false,
    };
  },
  mounted() {
    Validator.extend('rut', rutValidator);
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'zendesk')) {
      this.$set(this.complaint, 'zendesk', [this.$route.query.zendesk]);
      this.fetchData();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'booking')) {
      this.$set(this.complaint.ticket_info, 'booking_number', this.$route.query.booking);
      this.getTickets();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'category')) {
      this.$set(this.complaint, 'category', this.$route.query.category);
    }
    this.refreshReloaAppStatus();
  },
  watch: {
    selected() {
      const info = this.complaint.ticket_info;
      info.tickets = this.selected;
      const filtered = this.booking_tickets.filter(ticket =>
        this.selected.includes(ticket.number));

      if (filtered.length === 0) {
        this.hasBusbudTicket = false;
        info.fullname = '';
        info.email = null;
        info.departure_date = null;
        info.departure_hour = null;
        info.departure = null;
        info.arrival_date = null;
        info.arrival_hour = null;
        info.arrival = null;
        info.payment_method = null;
        info.price = null;
        info.price_usd = null;
        info.original_price = null;
        info.paypal_transaction = null;
        info.sold_currency = null;
        info.operator_currency = null;
        info.sales_company = null;
        info.is_whitelabel = null;
        info.ticket_ids = [];
        info.bus_operators = [];
        return;
      }

      this.hasBusbudTicket = filtered.some(ticket => String(ticket.agency).toLowerCase() === 'busbud');
      if (this.hasBusbudTicket) {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Advertencia',
          text: 'No es posible ingresar un reclamo preaprobado para un boleto Busbud.',
          duration: 5000,
        });
        return;
      }

      const dep = filtered[0];
      const arr = filtered[filtered.length - 1];
      info.departure_date = dep.departure_date;
      info.departure_hour = dep.departure_hour;
      info.departure = dep.departs_at;
      if (filtered.length > 1 && dep.inbound !== arr.inbound && arr.inbound) {
        info.arrival_date = arr.departure_date;
        info.arrival_hour = arr.departure_hour;
        info.arrival = arr.departs_at;
      } else {
        info.arrival_date = null;
        info.arrival_hour = null;
        info.arrival = null;
      }
      info.payment_method = filtered[0].payment_method;
      info.email = filtered[0].email;
      info.fullname = filtered[0].fullname;
      info.price = filtered.reduce((total, ticket) => total + parseInt(ticket.price, 10), 0);
      info.price_usd = filtered.reduce((total, ticket) =>
        total + parseFloat(ticket.price_usd, 10), 0);
      info.original_price = filtered.reduce((total, ticket) =>
        total + parseInt(ticket.original_price, 10), 0);
      info.payment_method = filtered[0].payment_method;
      info.paypal_transaction = filtered[0].paypal_transaction;
      info.sold_currency = filtered[0].sold_currency;
      info.operator_currency = filtered[0].operator_currency;
      info.sales_company = filtered[0].sales_company;
      info.is_whitelabel = filtered[0].is_whitelabel;
      info.ticket_ids = filtered.map(ticket => ticket.id);
      info.bus_operators = filtered.map((ticket) => {
        if (ticket.id === dep.id) {
          return dep.bus_operator;
        } else if (ticket.id === arr.id) {
          return arr.bus_operator;
        }
        return ticket.bus_operator;
      }).filter((val, i, self) => self.indexOf(val) === i);
    },
  },
  methods: {
    create() {
      const $this = this;
      if (this.hasBusbudTicket) {
        return;
      }
      if (!this.complaint.comment) {
        this.$notify({
          group: 'request',
          type: 'warning',
          title: 'Advertencia',
          text: 'Debe llenar una plantilla',
          duration: 3000,
        });
        return;
      }
      if (this.template_selected) {
        this.complaint.comment = this.template_selected;
      }
      $this.saveComplaint();
    },
    setTemplateSelected(event) {
      if (!event) {
        this.template_selected = '';
        this.templateModalText = '';
        return;
      }
      const ticketInfo = (this.complaint && this.complaint.ticket_info) || {};
      const busOperators = Array.isArray(ticketInfo.bus_operators) ? ticketInfo.bus_operators : [];
      const genderRaw = (this.complaint && this.complaint.issuer_gender) || '';
      const genderNormalized = String(genderRaw).toLowerCase();
      let genderText = '';
      if (['mujer', 'female', 'f'].includes(genderNormalized)) {
        genderText = 'La';
      } else if (['hombre', 'male', 'm'].includes(genderNormalized)) {
        genderText = 'Lo';
      }
      const replaceOrKeep = (value, token) => value || token;
      const templateText = String(event)
        .replace(/\[date\]/g, replaceOrKeep(ticketInfo.departure_date, '[date]'))
        .replace(/\[hour\]/g, replaceOrKeep(ticketInfo.departure_hour, '[hour]'))
        .replace(/\[bus_operator\]/g, replaceOrKeep(busOperators[0], '[bus_operator]'))
        .replace(/\[gender\]/g, replaceOrKeep(genderText, '[gender]'));
      this.templateModalText = templateText;
      this.templateModalOpen = true;
    },
    handleTemplateModalClose(text) {
      this.templateModalOpen = false;
      this.template_selected = text;
      if (text) {
        this.complaint.comment = text;
      }
    },
    handleTemplateModalCancel() {
      this.templateModalOpen = false;
    },
    saveComplaint() {
      const $this = this;
      kexaApi.post(this.complaint).then(() => {
        router.push('/complaints');
      }).catch((res) => {
        $this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: res.body,
          duration: 3000,
        });
      });
    },
    fetchData() {
      const ticket = this.complaint.zendesk[0];
      if (ticket === undefined) {
        this.$set(this.complaint, 'first_contact', null);
        this.$set(this.complaint, 'last_contact', null);
        this.$set(this.complaint, 'issuer_contact', null);
        this.$set(this.complaint, 'issuer_name', null);
        this.$set(this.complaint, 'source', null);
        this.$set(this.complaint, 'description', null);
        this.first_ticket = null;
      } else if (this.first_ticket !== ticket) {
        this.loader = true;
        kexaApi.zendeskInfo(this.complaint.zendesk[0]).then((res) => {
          this.loader = false;
          const t = res.body.ticket;
          const created = dateService.getDate(t.created_at);
          const updated = dateService.getDate(t.updated_at);
          this.$set(this.complaint, 'first_contact', created);
          this.$set(this.complaint, 'last_contact', updated);
          this.$set(this.complaint, 'issuer_contact', this.getIssuerData(t.via));
          this.$set(this.complaint, 'issuer_name', t.via.source.from.name);
          this.$set(this.complaint, 'source', t.via.channel);
          this.$set(this.complaint, 'description', t.description);
          this.first_ticket = this.complaint.zendesk[0];
        }).catch(() => {
          this.$notify({
            group: 'request',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error con ese ticket de Zendesk.',
            duration: 3000,
          });
        });
      }
    },
    getTickets() {
      this.getTicketsLoader = true;
      this.getTicketsError = false;
      this.hasBusbudTicket = false;
      kexaApi.ticketInfo(this.complaint.ticket_info.booking_number, '', 'pre_approved').then((res) => {
        console.log('Response from KexaApi');
        console.log(res);
        this.getTicketsLoader = false;
        this.$set(this, 'booking_tickets', res.body.data);
        if (res.body.data.length !== 0) {
          this.$set(this.complaint.ticket_info, 'booking_number', res.body.data[0].token);
        }

        const invalidTickets = res.body.invalid_tickets;

        if (invalidTickets.length > 0) {
          this.$notify({
            group: 'request',
            type: 'warning',
            title: 'Advertencia',
            text: `Los tickets con número: ${invalidTickets} incumplen una de las siguientes condiciones:` +
            '<br>- Tiene categoría Transbank error y más de 90 días a partir de la fecha de salida' +
            '<br>- Tiene categoría Reclamo cupón y más de los 6 meses del periodo de validez' +
            '<br>- Tienen otra categoría y más de 30 días a partir de la fecha de salida',
            duration: 8000,
          });
        }
      }).catch((e) => {
        console.log('An error was found');
        console.log(e);
        this.getTicketsError = true;
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'Número de compra no encontrado',
          duration: 3000,
        });
      });
    },
    formatOperator(value) {
      return (value.length === 2) ? `${value[0]} (Ida) ${value[1]} (Vuelta)` : `${value[0]}`;
    },
    getIssuerData(src) {
      if (src.channel === 'email') {
        return src.source.from.address;
      }
      if (src.channel === 'facebook') {
        return src.source.from.profile_url;
      }
      return src.source.from.phone;
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  $icon-color: #007bff;
  $light-green: #a3d29d;

  .positive-action {
    background: {
      color: $light-green;
    }
    border-color: $light-green;
    color: #000000;
    border-radius: 0;
    font: {
      size: 24px;
    }
    padding: 10px 20px;
    &.btn-primary:not([disabled]) {
      &:hover,
      &:focus,
      &:active {
        color: #000000;
        border-color: $light-green;
        background-color: lighten($light-green, 2%);
        box-shadow: 0 0 0 0.2rem rgba($light-green, 0.2);
      }
    }
    &:disabled,
    &.disabled {
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  .form-horizontal {
    label {
      font: {
        weight: bold;
      }
    }
    .vue-input-tag-wrapper {
      .new-tag,
      .input-tag {
        font: {
          size: 1rem;
        }
        color: #000;
      }
      .input-tag {
        background: {
          color: $light-green;
        }
      }
    }
    .form-group {
      @media screen and (min-width: 768px) {
        min-width: 456px;
      }
    }
  }
  .loader-in-field.fa-icon {
    color: $icon-color;
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .get-tickets-response {
    position: absolute;
    right: 84px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    color: #007bff;
    &.has-error {
      color: red;
    }
    &.tickets-found {
      color: green;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/complaints/NewPreApproved.vue